import React, { useState } from 'react';
import { Button, Dialog, DialogContent, DialogTitle } from '@mui/material';
import { BsPlusLg } from 'react-icons/bs';

import { themeExpert } from '../../theme/expert';
import { ThemeProvider } from '@mui/material/styles';
import CreateExpertise from './createExpertise';

/**
 * Le bouton « Nouvelle expertise » et sa fenêtre.
 *
 * Le formulaire ignorait les fonctions qu'on lui passait : la fenêtre ne se
 * fermait jamais après création, et la liste derrière ne se rafraîchissait
 * pas. On croyait avoir raté la création, et on recommençait.
 *
 * `ThemeProvider` est répété ici parce qu'une `Dialog` se rend dans un portail,
 * hors de la coquille : sans lui, elle retomberait sur le thème par défaut.
 */
function ModalCreateExpertise({ onCree, onFerme }) {
  const [ouvert, setOuvert] = useState(false);

  const fermer = () => {
    setOuvert(false);
    if (onFerme) onFerme();
  };

  return (
    <>
      <Button variant="contained" startIcon={<BsPlusLg />}
              onClick={() => setOuvert(true)}>
        Nouvelle expertise
      </Button>

      <ThemeProvider theme={themeExpert}>
        <Dialog open={ouvert} onClose={fermer} fullWidth maxWidth="sm">
          <DialogTitle>Créer une expertise</DialogTitle>
          <DialogContent>
            <CreateExpertise onCree={onCree} onAnnule={fermer} />
          </DialogContent>
        </Dialog>
      </ThemeProvider>
    </>
  );
}

export default ModalCreateExpertise;
